import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

// Commons
import alertsEn from '../locales/en/commons/alerts.json';
import alertsFr from '../locales/fr/commons/alerts.json';
import errorsEn from '../locales/en/commons/errors.json';
import errorsFr from '../locales/fr/commons/errors.json';

// Components
import FaqEn from '../locales/en/components/faq.json';
import FaqFr from '../locales/fr/components/faq.json';
import ActionBottomBarEn from '../locales/en/components/action_bottom_bar.json';
import ActionBottomBarFr from '../locales/fr/components/action_bottom_bar.json';
import DatatableEn from '../locales/en/components/datatables.json';
import DatatableFr from '../locales/fr/components/datatables.json';
import LayoutEn from '../locales/en/components/layout.json';
import LayoutFr from '../locales/fr/components/layout.json';

// Views
import dashboardEn from '../locales/en/views/dashboard.json';
import dashboardFr from '../locales/fr/views/dashboard.json';

import StatisticsEn from '../locales/en/views/statistics.json';
import StatisticsFr from '../locales/fr/views/statistics.json';

import UsersEn from '../locales/en/views/users.json';
import UsersFr from '../locales/fr/views/users.json';

// New
import TemplatesEn from '../locales/en/views/templates.json';
import TemplatesFr from '../locales/fr/views/templates.json';
import DocumentsEn from '../locales/en/views/documents.json';
import DocumentsFr from '../locales/fr/views/documents.json';
import RecordingsEn from '../locales/en/views/recordings.json';
import RecordingsFr from '../locales/fr/views/recordings.json';

import CompanySettingsEn from '../locales/en/views/company_settings.json';
import CompanySettingsFr from '../locales/fr/views/company_settings.json';

const resources = {
    en: {
        templates: TemplatesEn, // New
        documents: DocumentsEn, // New
        recordings: RecordingsEn, // New
        dashboard: dashboardEn, // New

        layout: LayoutEn,

        alerts: alertsEn,
        errors: errorsEn,
        faq: FaqEn,
        action_bottom_bar: ActionBottomBarEn,
        datatables: DatatableEn,

        users: UsersEn,

        statistics: StatisticsEn,

        company_settings: CompanySettingsEn,
    },
    fr: {
        templates: TemplatesFr, // New
        documents: DocumentsFr, // New
        recordings: RecordingsFr, // New
        dashboard: dashboardFr, // New

        layout: LayoutFr,

        alerts: alertsFr,
        errors: errorsFr,
        faq: FaqFr,
        action_bottom_bar: ActionBottomBarFr,
        datatables: DatatableFr,

        users: UsersFr,

        statistics: StatisticsFr,

        company_settings: CompanySettingsFr,
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        ns: ['common'],
        resources,
        fallbackLng: 'en',

        interpolation: {
            // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
            escapeValue: false,
        },
    });
